// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ebced474","453":"896031f3"}[chunkId] + ".chunk.js";
};